
import { FrequencyDocumentService } from "@/services/frequency-document-service";
import { isGreaterOrEqualDate } from "@/utils/date-utils";
import { printLocalDate } from "@/utils/pretty-print";
import Vue from "vue";
import { FrequencyDocumentEditState } from "../../utils/frequency-document-edit-state";
import { HttpError } from "../../utils/services/http-error";

export default Vue.extend({
	data() {
		return {
			dates: [] as Date[],
			errorMessage: ""
		};
	},
	props: {
		state: {
			type: Object as () => FrequencyDocumentEditState,
			required: true
		}
	},
	computed: {
		readableDates():string[] {
			return this.dates.map(d => {
				let str = printLocalDate(d);
				str = `${this.$ct(`common.weekday.${d.getDay() - 1}`).toString()} ${str}`;
				return str;
			});
		}
	},
	async mounted() {
		try {
			this.dates = await FrequencyDocumentService.checkExecutionDates(
				this.state.doc.StartDate,
				this.state.doc.EndDate,
				this.state.doc.FrequencyType,
				this.state.doc.FrequencyMoment,
				this.state.doc.Interval,
				this.state.doc.ID != 0 && isGreaterOrEqualDate(new Date(), this.state.doc.StartDate),
			);
		} catch(err) {
			let error = err as HttpError;
			error.dontShow = true;
			this.errorMessage = error.getText();
		}
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
